import CityPageTemplate from "../city-template/CityPageTemplate";
import { hagerstownConfig } from "./data";

export default function HagerstownPage() {
  return <CityPageTemplate config={hagerstownConfig} />;
}